import { render } from "./DocumentsManagement.html?vue&type=template&id=35683c81&scoped=true"
import script from "./DocumentsManagement.js?vue&type=script&lang=js"
export * from "./DocumentsManagement.js?vue&type=script&lang=js"

import "./DocumentsManagement.css?vue&type=style&index=0&id=35683c81&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35683c81"]])

export default __exports__